import axios, { type AxiosInstance } from 'axios'
import { env } from '@/shared/config/env'

export const http: AxiosInstance = axios.create({
  baseURL: env.apiUrl,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: { indexes: null },
})

export const publicHttp: AxiosInstance = http
export const privateHttp: AxiosInstance = http

if (typeof window !== 'undefined' && import.meta.env.DEV) {
  ;(window as unknown as { __authedHttp?: AxiosInstance }).__authedHttp = http
}
